import {
    type ApiEndpoint,
    type DownloadUrlResponse,
    isDownloadUrlResponse,
} from "@/shared/api-endpoint";
import { isObject } from "@/shared/utils/typeGuards";

export const kVariations30Route = "/variations-3.0";

export interface Variations30RequestBody {
    fileKey: string;
    bpm: number;
    pitchPalette?: number[];
    complexity?: number;
    naturalness?: number;
    transposition?: number;
    seed?: number;
    secondsEnd?: number;
}

export const isVariations30RequestBody = (value: unknown): value is Variations30RequestBody =>
    isObject(value) && typeof value.fileKey === "string" && typeof value.bpm === "number";

export const kVariations30Endpoint: ApiEndpoint<Variations30RequestBody, DownloadUrlResponse> = {
    route: kVariations30Route,
    label: "Variations 3.0",
    source: "Modal",
    category: "SpliceGen v3.0",
    description: "Variations using the SpliceGen 3.0 model for richer harmonic expression.",
    isRequestBody: isVariations30RequestBody,
    isSuccessResponse: isDownloadUrlResponse,
};
